import React from 'react';
import { getShortName } from '../utils/nameFormatting';
import RecentConversations from '../components/dashboard/RecentConversations';
import NeedsAttention from '../components/dashboard/NeedsAttention';
import UpcomingBookings from '../components/dashboard/UpcomingBookings';
import DashboardAvailability from '../components/dashboard/DashboardAvailability';
import PaymentsReceived from '../components/dashboard/PaymentsReceived';
import '../styles/pages/HomePagePhotographer.css';

const HomePagePhotographer = ({ userName }) => {
  const firstName = getShortName(userName);

  return (
    <main className="photographer-dashboard">
      <div className="photographer-dashboard__overview">
        <header className="photographer-dashboard__welcome">
          <p>Your dashboard</p>
          <h1>Welcome back{firstName ? `, ${firstName}` : ''}</h1>
        </header>
        <NeedsAttention />
      </div>
      <PaymentsReceived />
      <div className="photographer-dashboard__workspace">
        <UpcomingBookings />
        <DashboardAvailability />
        <RecentConversations />
      </div>
    </main>
  );
};

export default HomePagePhotographer;
